<template>
  <base-account :menu="true">
    <section class="section hero-section bg-ico-hero" id="home">
      <div class="bg-overlay bg-primary"></div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-5">
            <div class="text-white-50">
              <h1 class="text-white font-weight-semibold mb-3 hero-title">
                {{ entidade.ent_nome }}
              </h1>
              <h2 class="text-white font-weight-semibold mb-3">
                Nota Fiscal de Serviços Eletrônica
              </h2>
              <p class="font-size-14">
                A Nota Fiscal de Serviços Eletrônica (NFS-e) é o documento fiscal de existência apenas digital que
                substituirá as tradicionais notas fiscais de serviços impressas.
              </p>
              <div class="button-items mt-4">
                <router-link
                    tag="a"
                    to="/register"
                    class="btn btn-success">Criar conta
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-8 col-sm-10 ml-lg-auto">
            <div class="card overflow-hidden mb-5 mt-5 mt-lg-0">
              <div class="card-header text-center">
                <h5 class="mb-0">Acessar Conta</h5>
              </div>
              <div class="card-body">
                <div role="alert" v-show="authError" aria-live="polite" aria-atomic="true"
                     class="alert alert-danger">
                  <i class="mdi mdi-block-helper mr-2"></i> {{ authError }}
                </div>
                <Loader :loading="httpSend">
                  <b-form class="p-2" @submit.prevent="tryToLogIn">
                    <b-form-group
                        id="input-group-1"
                        label="CPF"
                        label-for="input-1">
                      <input
                          id="input-1"
                          autocomplete="no"
                          v-mask="'###.###.###-##'"
                          v-model="user.pes_cpfcnpj"
                          type="text"
                          class="form-control"
                          placeholder="Entre com seu CPF"
                          :class="{ 'is-invalid': submitted && $v.user.pes_cpfcnpj.$error }"
                      >
                      <div v-show="submitted && $v.user.pes_cpfcnpj.$error" class="invalid-feedback">
                        <span>Informe seu CPF</span>
                      </div>
                    </b-form-group>
                    <b-form-group
                        id="input-group-2"
                        label="Senha"
                        label-for="input-2">
                      <div class="input-group mb-3">
                        <input
                            id="input-2"
                            autocomplete="no"
                            v-model="user.aut_senha"
                            v-bind:type="showPassword?'text':'password'"
                            placeholder="Senha"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && $v.user.aut_senha.$error }">
                        <div v-if="submitted && $v.user.aut_senha.$error" class="invalid-feedback">
                          Informe sua senha
                        </div>
                        <div class="input-group-append">
                          <label class="input-group-text">
                            <a style="cursor: pointer" @click="altershowPassword()" class="is-link">
                              <i v-show="!showPassword" class="fa fa-eye-slash" aria-hidden="true"></i>
                              <i v-show="showPassword" class="fa fa-eye" aria-hidden="true"></i>
                            </a>
                          </label>
                        </div>
                      </div>
                    </b-form-group>
                    <div class="mt-3">
                      <b-button type="submit" variant="primary" class="btn-block">Entrar
                      </b-button>
                    </div>
                    <div class="mt-4 text-center">
                      <router-link tag="a" to="/forgot-password" class="text-muted">
                        <i class="mdi mdi-lock mr-1"></i> Esqueceu sua senha?
                      </router-link>
                    </div>
                  </b-form>
                </Loader>
              </div>
              <div class="text-center">
                <p>
                  Não tem conta ?
                  <router-link
                      tag="a"
                      to="/register"
                      class="font-weight-medium text-primary">Crie agora
                  </router-link>
                </p>
              </div>
            </div>

            <div class="card overflow-hidden mb-0 mt-5 mt-lg-0">
              <div class="card-header text-center">
                <h5 class="mb-0">Validar Nota</h5>
              </div>
              <div class="card-body">
                <Loader :loading="httpSendValid">
                  <b-form class="p-2" @submit.prevent="tryToValida">
                    <div class="row">
                      <div class="col-md-6">
                        <b-form-group
                            label="CPF/CNPJ Prestador"
                            label-for="sep_cpf_cnpj_prestador">
                          <the-mask
                              id="sep_cpf_cnpj_prestador"
                              autocomplete="no"
                              v-model="valida.sep_cpf_cnpj_prestador"
                              type="text"
                              class="form-control"
                              placeholder=""
                              :class="{ 'is-invalid': submittedValidacao && $v.valida.sep_cpf_cnpj_prestador.$error }"
                              :mask="['###.###.###-##', '##.###.###/####-##']"/>
                          <div v-show="submittedValidacao && $v.valida.sep_cpf_cnpj_prestador.$error"
                               class="invalid-feedback">
                            <span>Informe a de emissão da nota</span>
                          </div>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                            label="Codigo de Verificação"
                            label-for="not_verificacao">
                          <input
                              id="not_verificacao"
                              autocomplete="no"
                              v-mask="'NNNN-NNNN'"
                              v-model="valida.not_verificacao"
                              type="text"
                              class="form-control text-uppercase"
                              placeholder="####-####"
                              :class="{ 'is-invalid': submittedValidacao && $v.valida.not_verificacao.$error }">
                          <div v-show="submittedValidacao && $v.valida.not_verificacao.$error" class="invalid-feedback">
                            <span>Informe o codigo de verificação da nota</span>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div role="alert" v-show="errorValidacao" aria-live="polite" aria-atomic="true"
                           class="alert alert-danger">
                        <i class="mdi mdi-block-helper mr-2"></i> {{ mensagemValidacao }}
                      </div>
                    </div>
                    <div class="mt-3">
                      <b-button type="submit" variant="success" class="btn-block">Validar</b-button>
                    </div>
                  </b-form>
                </Loader>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
    <section class="section bg-white p-0">
      <div class="container">
        <div class="currency-price">
          <div class="row">
            <div class="col-md-4">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-xs mr-3">
                        <span class="avatar-title rounded-circle bg-soft-warning text-warning font-size-18">
                          <i class="mdi mdi-account"></i>
                        </span>
                    </div>
                    <div class="media-body text-right">
                      <p class="text-muted">Contribuintes Cadastrados</p>
                      <h3>{{ contadores.total_contribuinte }}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-xs mr-3">
                        <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                          <i class="mdi mdi-text-box-check"></i>
                        </span>
                    </div>
                    <div class="media-body text-right">
                      <p class="text-muted">Notas Emitidas</p>
                      <h3>{{ contadores.total_nota }}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar-xs mr-3">
                        <span class="avatar-title rounded-circle bg-soft-info text-info font-size-18">
                          <i class="mdi mdi-currency-brl"></i>
                        </span>
                    </div>
                    <div class="media-body text-right">
                      <p class="text-muted">Valor Movimentado</p>
                      <h3>{{ contadores.total_movimento | formatNumeroBr }}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
      </div>
      <!-- end container -->
    </section>
    <section class="section" id="features">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mb-5">
              <div class="small-title">Tecnologia</div>
              <h4>Eficiência e tecnologia de ponta</h4>
            </div>
          </div>
        </div>
        <div class="row align-items-center pt-4">
          <div class="col-md-6 col-sm-8">
            <div>
              <img src="@/assets/images/crypto/features-img/img-1.png" alt
                   class="img-fluid mx-auto d-block"/>
            </div>
          </div>
          <div class="col-md-5 ml-auto">
            <div class="mt-4 mt-md-auto">
              <div class="d-flex align-items-center mb-2">
                <div class="features-number font-weight-semibold display-4 mr-3">01</div>
                <h4 class="mb-0">Cloud Computing</h4>
              </div>
              <p class="text-muted">
                Computação em nuvem que proporciona o desempenho e a confiabilidade necessária
                para garantir a continuidade das operações 24 horas por dia, 7 dias por semana.
              </p>
              <div class="text-muted mt-4">
                <p class="mb-2">
                  <i class="mdi mdi-circle-medium text-success mr-1"></i>Servidores e armazenamento escaláveis;
                </p>
                <p>
                  <i class="mdi mdi-circle-medium text-success mr-1"></i>Rede de distribuição de conteúdo (CDN) para
                  agilizar a entrega dos dados;
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->

        <div class="row align-items-center mt-5 pt-md-5">
          <div class="col-md-5">
            <div class="mt-4 mt-md-0">
              <div class="d-flex align-items-center mb-2">
                <div class="features-number font-weight-semibold display-4 mr-3">02</div>
                <h4 class="mb-0">Segurança de Dados</h4>
              </div>
              <p class="text-muted">
                Utilizamos dados criptografados, que conta também com dupla autenticação, sendo validada por token.
              </p>
              <div class="text-muted mt-4">
                <p class="mb-2">
                  <i class="mdi mdi-circle-medium text-success mr-1"></i>Criptografia de nível militar;
                </p>
                <p>
                  <i class="mdi mdi-circle-medium text-success mr-1"></i>Troca de dados segura em duas etapas;
                </p>
                <p>
                  <i class="mdi mdi-circle-medium text-success mr-1"></i>Banco de dados criptografado;
                </p>
                <p>
                  <i class="mdi mdi-circle-medium text-success mr-1"></i>Backups automatizados com redundância
                  geográfica.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-8 ml-md-auto">
            <div class="mt-4 mr-md-0">
              <img src="@/assets/images/crypto/features-img/img-2.png"
                   alt class="img-fluid mx-auto d-block"/>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
  </base-account>
</template>
<script>
import {required} from "vuelidate/lib/validators";
import {mapState} from "vuex";
import {authMethods} from "@/state/helpers";
import {TheMask} from 'vue-the-mask'
import Loader from "@/components/widgets/loader"
import {getIndex, validaNota} from "@/api/core";
import BaseAccount from "@/router/layouts/base-account"

export default {
  components: {
    BaseAccount,
    TheMask,
    Loader
  },
  data() {
    return {
      entidade: {},
      contadores: {},
      user: {
        pes_cpfcnpj: "",
        aut_senha: ""
      },
      valida: {
        sep_cpf_cnpj_prestador: "",
        not_verificacao: ""
      },
      httpSend: false,
      httpSendValid: false,
      submitted: false,
      submittedValidacao: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      errorValidacao: false,
      mensagemValidacao: '',
      showPassword:false
    };
  },
  validations: {
    user: {
      pes_cpfcnpj: {
        required,
      },
      aut_senha: {
        required,
      },
    },
    valida: {
      sep_cpf_cnpj_prestador: {
        required,
      },
      not_verificacao: {
        required,
      },
    }
  },
  created() {
    this.getEntidade();
    window.addEventListener("scroll", this.windowScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  computed: {
    ...mapState("authfack", ["status"]),
  },
  methods: {
    ...authMethods,
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
      ) {
        navbar.classList.add("nav-sticky");
      } else {
        navbar.classList.remove("nav-sticky");
      }
    },
    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
    altershowPassword() {
      this.showPassword = !this.showPassword;
    },
    getEntidade() {
      getIndex().then(response => {
        if (response.status) {
          this.entidade = response.dados.parametros;
          this.contadores = response.dados.contadores;
        }
      }).catch(error => {
        console.log(error)
      })
    },
    tryToLogIn() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.user.$invalid) {
        return;
      } else {
        this.httpSend = true;
        this.logIn(this.user)
            .catch((erro) => {
              this.authError = erro;
            }).finally(() => {
          this.httpSend = false;
        })
      }
    },
    tryToValida() {
      this.submittedValidacao = true;
      this.$v.$touch();
      if (this.$v.valida.$invalid) {
        return;
      } else {
        this.httpSendValid = true;
        validaNota(this.valida).then(response => {
          if (response.status) {
            this.$router.push({name: 'public-nota', params: {not_hash: response.dados.not_hash}})
          } else {
            this.errorValidacao = true;
            this.mensagemValidacao = response.mesagem;
          }
        }).catch(error => {
          console.log(error)
        }).finally(() => {
          this.httpSendValid = false;
        })
      }
    },
  }
};
</script>

